import { DataSource, Label, Layout, Map, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutMarketAreaList extends Layout {
    labelSearchMarketArea: Label;
    mapRoute: Map;
    sourceMarketArea: DataSource;
    splitterMarketArea: Splitter;
    tableMarketAreaList: Table;
}
